import { Stamps } from 'components/Icon';

export const StampType = Object.keys(Stamps).reduce((acc, v) => {
    acc[v] = v;
    return acc;
}, {});

export const StampMap = Stamps
